<ng-container *ngTemplateOutlet="skeleton"></ng-container>

<ng-template #skeleton>
  <!-- The course bar: a white rounded surface, three facts on the left and the
       pause-course action on the right. (.watch-bar itself is scoped to the
       page component, so a plain .card stands in for the surface here.) -->
  <div class="card">
    <div class="card-body d-flex flex-row flex-wrap justify-content-between align-items-center gap-4 py-4">
      <div class="d-flex flex-wrap align-items-center gap-3 gap-md-8">
        <div class="d-flex align-items-center gap-2">
          <div class="skeleton rounded-circle h-20px w-20px"></div>
          <div class="skeleton h-15px w-90px"></div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <div class="skeleton rounded-circle h-20px w-20px"></div>
          <div class="skeleton h-15px w-75px"></div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <div class="skeleton rounded-circle h-20px w-20px"></div>
          <div class="skeleton h-15px w-150px"></div>
        </div>
      </div>
      <div class="skeleton h-40px w-100 mw-175px"></div>
    </div>
  </div>

  <!-- Video on the left, chapter playlist on the right. -->
  <div class="row g-5 mt-6">
    <div class="col-12 col-xl-8 mb-5 mb-xl-0 mt-0">
      <div class="skeleton min-h-400px mh-500px w-100 rounded"></div>
    </div>
    <div class="col-12 col-xl-4 mt-0">
      <div class="card watch-playlist">
        <ng-container *ngTemplateOutlet="skeletonChapter"></ng-container>
        <ng-container *ngTemplateOutlet="skeletonChapter"></ng-container>
        <ng-container *ngTemplateOutlet="skeletonChapter"></ng-container>
        <ng-container *ngTemplateOutlet="skeletonChapter"></ng-container>
        <ng-container *ngTemplateOutlet="skeletonChapter"></ng-container>
      </div>
    </div>
  </div>

  <!-- Course info card: two tabs, the title block with its facts, the
       description and the quiz list. -->
  <div class="card mt-5 min-h-350px">
    <div class="card-header card-header-stretch">
      <div class="card-toolbar d-flex flex-row align-items-center gap-6 m-0 min-h-70px">
        <div class="skeleton h-25px w-100px"></div>
        <div class="skeleton h-25px w-80px"></div>
      </div>
    </div>

    <div class="card-body">
      <section>
        <div class="d-flex flex-row align-items-center gap-4 mb-4">
          <div class="skeleton h-30px w-25 mw-300px"></div>
          <div class="skeleton h-20px w-100px"></div>
        </div>
        <div class="d-flex flex-row flex-wrap align-items-center gap-6">
          <div class="skeleton h-20px w-100px"></div>
          <div class="skeleton h-20px w-125px"></div>
          <div class="skeleton h-20px w-150px"></div>
        </div>
      </section>

      <section>
        <div class="skeleton h-30px w-150px mt-12 mb-5"></div>
        <div class="skeleton h-20px w-100 mb-2"></div>
        <div class="skeleton h-20px w-100 mb-2"></div>
        <div class="skeleton h-20px w-75"></div>
      </section>

      <section>
        <div class="skeleton h-30px w-150px mt-12 mb-5"></div>
        <div class="card">
          <div class="card-body p-6 d-flex flex-row align-items-center gap-3">
            <div class="skeleton rounded-circle h-35px w-35px"></div>
            <div class="d-flex flex-column gap-2 flex-grow-1">
              <div class="skeleton h-20px w-50 mw-250px"></div>
              <div class="skeleton h-15px w-25 mw-150px"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</ng-template>

<ng-template #skeletonChapter>
  <div class="lesson-group">
    <div class="skeleton rounded-circle h-35px w-35px flex-shrink-0"></div>
    <div class="d-flex flex-column gap-2 flex-grow-1">
      <div class="skeleton h-15px w-75 mw-150px"></div>
      <div class="skeleton h-15px w-100px"></div>
    </div>
    <div class="skeleton h-15px w-60px flex-shrink-0"></div>
  </div>
</ng-template>
